import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Badge,
  Card,
  CardBody,
  Alert,
} from "reactstrap";
import { format } from "date-fns";
import EditScheduleModal from "../../CampaignSchedule/EditScheduleModal";
import "./ViewScheduleModal.css";
import CampaignSchedule from "../../../services/OrderingServices/CampaignSchedule";
import toast from "react-hot-toast";

const ViewScheduleModal = ({ isOpen, onClose, campaign, onScheduleUpdate }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  if (!campaign) return null;

  const schedule = campaign.campaignScheduleDetails;
  console.log("🚀 ~ ViewScheduleModal ~ schedule:", schedule);
  const hasSchedule = schedule && schedule.id;

  const getActiveDays = () => {
    if (!schedule) return [];
    const days = [];
    if (schedule.sunday) days.push("Sunday");
    if (schedule.monday) days.push("Monday");
    if (schedule.tuesday) days.push("Tuesday");
    if (schedule.wednesday) days.push("Wednesday");
    if (schedule.thursday) days.push("Thursday");
    if (schedule.friday) days.push("Friday");
    if (schedule.saturday) days.push("Saturday");
    return days;
  };

  const formatTime = (timeString) => {
    try {
      if (!timeString) return "N/A";
      const [hours, minutes] = timeString.split(":");
      const hour = parseInt(hours);
      const ampm = hour >= 12 ? "PM" : "AM";
      const displayHour = hour % 12 || 12;
      return `${displayHour}:${minutes} ${ampm}`;
    } catch (err) {
      return timeString;
    }
  };

  const activeDays = getActiveDays();

  const handleAddSchedule = async (scheduleId, payload) => {
    try {
      // Format time as HH:mm:ss
      const formatTime = (dateArray) => {
        if (!dateArray || dateArray.length === 0) return "00:00:00";
        const date = dateArray[0];
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      };

      const scheduleData = {
        campaignIds: [campaign.id],
        startDate: payload.startDate,
        endDate: payload.endDate,
        sunday: payload.sunday,
        monday: payload.monday,
        tuesday: payload.tuesday,
        wednesday: payload.wednesday,
        thursday: payload.thursday,
        friday: payload.friday,
        saturday: payload.saturday,
        startTime: payload.startTime || formatTime(payload.startDate),
        endTime: payload.endTime || "23:59:59",
      };

      await CampaignSchedule.assignToCampaigns(scheduleData);
      toast.success("Campaign schedule created successfully");
      setShowEditModal(false);
      
      // Refresh campaign data if callback provided
      if (onScheduleUpdate) {
        await onScheduleUpdate();
      }
    } catch (error) {
      toast.error(error.message || "Failed to create schedule");
      throw error;
    }
  };

  const handleUpdateSchedule = async (scheduleId, payload) => {
    try {
      await CampaignSchedule.update(scheduleId, payload);
      toast.success("Campaign schedule updated successfully");
      setShowEditModal(false);
      
      // Refresh campaign data if callback provided
      if (onScheduleUpdate) {
        await onScheduleUpdate();
      }
    } catch (error) {
      toast.error(error.message || "Failed to update schedule");
      throw error;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered>
      <ModalHeader toggle={onClose}>Campaign Schedule Details</ModalHeader>
      <ModalBody>
        {/* Campaign Info */}
        {/* <Card className="mb-3 border">
          <CardBody className="bg-light">
            <Row>
              <Col md="6">
                <h5 className="mb-3">{campaign.name}</h5>
                {campaign.description && (
                  <p className="text-muted mb-0">{campaign.description}</p>
                )}
              </Col>
              <Col md="6" className="text-md-end">
                <div className="mb-2">
                  <Badge color={campaign.isDraft ? "secondary" : "primary"} className="me-2">
                    {campaign.isDraft ? "Draft" : "Published"}
                  </Badge>
                  <Badge color={campaign.isActive ? "success" : "warning"}>
                    {campaign.isActive ? "Active" : "Inactive"}
                  </Badge>
                </div>
                <small className="text-muted">
                  <i className="mdi mdi-video-box me-1"></i>
                  {campaign.adsCount || 0} Media Files
                </small>
              </Col>
            </Row>
          </CardBody>
        </Card> */}

        {hasSchedule ? (
          <>
            {/* Schedule Status */}
            {/* <div className="mb-3">
              <Badge
                color={schedule.isActive ? "success" : "warning"}
                pill
                style={{ fontSize: "14px", padding: "8px 16px" }}
              >
                <i className={`mdi mdi-${schedule.isActive ? "check-circle" : "pause-circle"} me-1`}></i>
                Schedule {schedule.isActive ? "Active" : "Inactive"}
              </Badge>
            </div> */}

            {/* Date Range */}
            <Card className="mb-3 border-0 shadow-sm">
              <CardBody>
                <h6 className="mb-3">
                  <i className="mdi mdi-calendar-range text-primary me-2"></i>
                  Schedule Duration
                </h6>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <small className="text-muted d-block mb-1">
                        Start Date
                      </small>
                      <strong>
                        {schedule.startDate
                          ? format(
                              new Date(schedule.startDate),
                              "MMMM d, yyyy 'at' h:mm a",
                            )
                          : "Not set"}
                      </strong>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <small className="text-muted d-block mb-1">
                        End Date
                      </small>
                      <strong>
                        {schedule.endDate
                          ? format(
                              new Date(schedule.endDate),
                              "MMMM d, yyyy 'at' h:mm a",
                            )
                          : "Ongoing"}
                      </strong>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Recurring Days */}
            <Card className="mb-3 border-0 shadow-sm">
              <CardBody>
                <h6 className="mb-3">
                  <i className="mdi mdi-calendar-week text-primary me-2"></i>
                  Recurring Days
                </h6>
                {activeDays.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2">
                    {[
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ].map((day) => {
                      const isActive = activeDays.includes(day);
                      return (
                        <Badge
                          key={day}
                          color={isActive ? "primary" : "light"}
                          style={{
                            fontSize: "13px",
                            padding: "8px 12px",
                            fontWeight: isActive ? "600" : "normal",
                            color: isActive ? "#fff" : "#6c757d",
                            border: isActive ? "none" : "1px solid #dee2e6",
                          }}
                        >
                          {day.substring(0, 3)}
                        </Badge>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-muted mb-0">No recurring days set</p>
                )}
              </CardBody>
            </Card>

            {/* Time Window */}
            <Card className="mb-3 border-0 shadow-sm">
              <CardBody>
                <h6 className="mb-3">
                  <i className="mdi mdi-clock-outline text-primary me-2"></i>
                  Daily Time Window
                </h6>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <small className="text-muted d-block mb-1">
                        Start Time
                      </small>
                      <strong className="fs-5">
                        {formatTime(schedule.startTime)}
                      </strong>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <small className="text-muted d-block mb-1">
                        End Time
                      </small>
                      <strong className="fs-5">
                        {formatTime(schedule.endTime)}
                      </strong>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Associated Ads */}
            {campaign.ads && campaign.ads.length > 0 && (
              <Card className="border-0 shadow-sm">
                <CardBody>
                  <h6 className="mb-3">
                    <i className="mdi mdi-video-box text-primary me-2"></i>
                    Associated Media ({campaign.ads.length})
                  </h6>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Media</th>
                          <th>Type</th>
                          <th>Format</th>
                          <th>Duration</th>
                          <th>Advertiser</th>
                        </tr>
                      </thead>
                      <tbody>
                        {campaign.ads.map((ad) => (
                          <tr key={ad.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div
                                  className="flex-shrink-0 me-2"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <i
                                    className={`mdi mdi-${
                                      ad.mediaType === "Video"
                                        ? "video"
                                        : "image"
                                    } text-primary`}
                                    style={{ fontSize: "20px" }}
                                  ></i>
                                </div>
                                <div>
                                  <div className="fw-semibold">{ad.title}</div>
                                  {ad.description && (
                                    <small className="text-muted">
                                      {ad.description}
                                    </small>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <Badge color="info" className="bg-soft-info">
                                {ad.mediaType}
                              </Badge>
                            </td>
                            <td>{ad.adFormat}</td>
                            <td>{ad.duration}s</td>
                            <td>
                              <small className="text-muted">
                                {ad.advertiserName}
                              </small>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            )}
          </>
        ) : (
          <Alert color="info">
            <i className="mdi mdi-information me-2"></i>
            <strong>No Schedule Set</strong>
            <p className="mb-0 mt-2">
              This campaign doesn't have a recurring schedule. Click the "Create Schedule" button below to add one.
            </p>
          </Alert>
        )}
      </ModalBody>
      <ModalFooter>
        {hasSchedule ? (
          <Button
            color="primary"
            onClick={() => setShowEditModal(true)}
            className="me-auto"
          >
            <i className="mdi mdi-pencil me-1"></i>
            Update Schedule
          </Button>
        ) : (
          <Button
            color="success"
            onClick={() => setShowEditModal(true)}
            className="me-auto"
          >
            <i className="mdi mdi-calendar-plus me-1"></i>
            Create Schedule
          </Button>
        )}
        <Button color="light" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>

      {/* Add/Edit Schedule Modal */}
      <EditScheduleModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        schedule={hasSchedule ? {
          ...schedule,
          campaignName: campaign.name,
        } : {
          campaignId: campaign.id,
          campaignName: campaign.name,
        }}
        onUpdate={hasSchedule ? handleUpdateSchedule : handleAddSchedule}
        isAddMode={!hasSchedule}
      />
    </Modal>
  );
};

export default ViewScheduleModal;
